


























import { Component, Watch } from 'vue-property-decorator'
import { InstitutionAccountModule } from '@/store/Accounts/InstitutionAccountModule';
import { AuthModule } from '@/store/Auth/AuthModule';
import Alert from '@/components/Shared/Alert.vue';
import PageNames from '@/router/PageNames';
import InstitutionAccount from '@/models/Accounts/InstitutionAccounts/InstitutionAccount';
import SaascadaVue from '@/components/Shared/SaascadaVue';

@Component({ name: 'InstitutionAccountsList', components: { Alert }, metaInfo: { title: 'Accounts' } })
export default class extends SaascadaVue {

    headers = [
        { text: this.$t('pageText.institutionAccounts.fields.accountName'), sortable: false, width: "50%" },
        { text: this.$t('pageText.institutionAccounts.fields.availableBalance'), sortable: false, width: "25%" },
        { text: this.$t('pageText.institutionAccounts.fields.balance'), sortable: false, width: "25%" }
    ];
    accountsPage = 1;

    async created() {
        // Check for page number in URL parameters
        const page = this.$route.query.page;
        if (page) {
            this.accountsPage = +page;
        }
    }

    async beforeMount() {
        await InstitutionAccountModule.getInstitutionalAccounts();
    }

    get labels() {
        return AuthModule.me.institution.config.labels;
    }

    get accounts() {
        return InstitutionAccountModule.institutionalAccounts;
    }

    get totalAccountsPages() {
        return InstitutionAccountModule.totalInstitutionalAccountsPages;
    }

    get loading() {
        return InstitutionAccountModule.loadingInstitutionalAccounts;
    }

    get pageSize() {
        return InstitutionAccountModule.pageSize;
    }

    @Watch('accountsPage')
    async onAccountsPageChanged() {
        // Update current page route with page number
        this.$router.push({ name: this.$route.name, query: { page: `${this.accountsPage}` } });
    }

    async navigateToInstitutionalAccount(account: InstitutionAccount) {
        this.$router.push({ name: PageNames.InstitutionAccount, params: { id: account.id }, query: { tab: "0" } });
    }

}
